const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the privacy component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('privacy', ['Application', 'Categories', 'Groups', '$q', function (Application, Categories, Groups, $q) {
  return {
    restrict: 'E',
    scope: {
      content: '=',
      onChange: '&?',
      assessment: '=?'
    },
    template: require('../../../templates/directives/cms/content-privacy.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.flags = Application.features.flags();

      var initId;
      self.selectedCategoryIds = [];
      self.selectedGroupIds = [];
      self.userQuery = {};
      self.queries = [];
      self.userFields = '_id,role,first_name,last_name,full_name,email,linked_departments,linked_teams,linked_org_level,linked_grade,linked_locations,image,last_login';
      self.selectedFull = [];
      self.showGroupDisclaimer = false;

      var globalCategories = ['5a316142734d1d2932370349', '5a316104734d1d293237031b'];
      var globalGroups = ['606f5c8a89895023def821fa'];
      var segmentationOptions = ['privacy_departments', 'privacy_locations', 'privacy_teams', 'privacy_grades', 'privacy_org_levels', 'privacy_groups'];
      var typeOptions = ['location', 'department', 'team', 'grade', 'org_level'];

      var privacyMap = {
        privacy_locations: 'location',
        privacy_departments: 'department',
        privacy_teams: 'team',
        privacy_org_levels: 'org_level',
        privacy_grades: 'grade'
      };

      var typeToPrivacy = {
        location: 'privacy_locations',
        department: 'privacy_departments',
        team: 'privacy_teams',
        org_level: 'privacy_org_levels',
        grade: 'privacy_grades',
        group: 'privacy_groups'
      };

      var userFieldMap = {
        location: 'linked_locations',
        department: 'linked_departments',
        team: 'linked_teams',
        org_level: 'linked_org_level',
        grade: 'linked_grade',
        group: 'groups'
      };

      var legacyName = function(item) {
        var parentName;
        var papaName;

        item.text = item.name;
        item.lineage_ids = [item._id];

        if (item.parent && item.parent.name) {
          parentName = item.parent.name + ' -> ';
          item.text = parentName + item.text;
        }

        if (item.parent && item.parent.parent && item.parent.parent.name) {
          papaName = item.parent.parent.name + ' -> ';
          item.text = papaName + item.text;
        }
      };

      var checkPrivacy = function() {
        for (var i = 0; i < segmentationOptions.length; i++) {
          var value = $scope.content[segmentationOptions[i]];
          if (value && value.length) {
            for (var j = 0; j < value.length; j++) {
              if (globalCategories.indexOf(value[j].toString()) === -1) {
                return true;
              }
            }
          }
        }

        return false;
      };

      var restrictedGroup = Application.access.profile && Application.access.profile.permissions && Application.access.profile.permissions.admin && Application.access.profile.permissions.admin.content && Application.access.profile.permissions.admin.content.segmentation_group || {};

      // ------------- start ngTag triggered actions ------------

      self.removeAllTags = function() {
        self.queries.splice(0);

        for (var key in typeToPrivacy) {
          var item = typeToPrivacy[key];
          $scope.content[item] = [];
        }

        if ($scope.onChange) {
          $scope.onChange();
        }

      };

      self.itemAddedRemoved = function($tag, isRemoval) {
        var type = $tag.type;

        var privacyType = typeToPrivacy[type];

        if (!isRemoval && $tag.type === 'group') {
          const selectedGroups = [].concat(self.selectedGroupIds);
          selectedGroups.push($tag._id);
          self.selectedGroupIds.push($tag._id);
          self.queries.forEach(function(item) {
            if (item.type === 'group' && !selectedGroups.includes(item._id)) {
              selectedGroups.push(item._id);
            }
          });

          $scope.content.privacy_groups = selectedGroups;
        }

        if (!isRemoval && $tag.type !== 'group') {
          var existingValues = $scope.content[privacyType] || [];
          var checking = [].concat(existingValues);
          checking.push($tag._id);
          Categories.trimSelections({}, {selections: checking}).$promise
          .then(function(results) {
            var found = false;
            results.forEach(function(item) {
              if (item === $tag._id) {
                found = true;
              }
            });

            if (found) {
              var selections = [];

              self.selectedCategoryIds.push($tag._id);

              results.forEach(function(item) {
                if (globalCategories.indexOf(item) !== -1 || globalGroups.indexOf(item) !== -1) {
                  return;
                }
                selections.push(item);
              });

              for (var l = self.queries.length - 1; l >= 0; l--) {
                if (self.queries[l].type !== $tag.type) {
                  continue;
                }

                if (results.indexOf(self.queries[l]._id) === -1) {
                  self.queries.splice(l, 1);
                }
              }

              $scope.content[privacyType] = selections;

              if ($scope.onChange) {
                $scope.onChange();
              }

              self.setUserQuery();

              return;
            }

            for (var j = 0; j < self.queries.length; j++) {
              if (self.queries[j]._id === $tag._id) {
                self.queries.splice(j, 1);
                return;
              }
            }

          }).catch(function(error) {
            console.log('error in categories trim: ', error);
          });

          return;
        }

        if (isRemoval) {
          if (self.selectedGroupIds.indexOf($tag._id) !== -1) {
            self.selectedGroupIds.splice(self.selectedGroupIds.indexOf($tag._id), 1);
            $scope.content.privacy_groups.splice(self.selectedGroupIds.indexOf($tag._id), 1);
          }

          for (var i = 0; i < $scope.content[privacyType].length; i++) {
            if ($scope.content[privacyType][i] === $tag._id) {
              $scope.content[privacyType].splice(i, 1);
            }
          }
        }

        self.setUserQuery();

        if ($scope.onChange) {
          $scope.onChange();
        }
        self.showGroupDisclaimer = !!$scope.content.privacy_groups.length;
      };

      // ------------- End ngTag triggered actions ------------

      self.setUserQuery = function() {
        delete self.userQuery.cancel;
        delete self.userQuery.linked_grade;
        delete self.userQuery.linked_org_level;
        delete self.userQuery.linked_teams;
        delete self.userQuery.linked_departments;
        delete self.userQuery.linked_locations;
        delete self.userQuery.groups;

        self.userQuery.fields = self.userFields;
        self.userQuery['linked_grade-populate'] = 'name';
        self.userQuery['linked_org_level-populate'] = 'name';
        self.userQuery['linked_teams-populate'] = 'name';
        self.userQuery['linked_departments-populate'] = 'name';
        self.userQuery['linked_locations-populate'] = 'name';
        self.userQuery['groups-populate'] = 'name';

        var cancel = true;

        for (var key in typeToPrivacy) {
          var field = $scope.content[typeToPrivacy[key]];
          if (!field || !field.length) {
            continue;
          }

          // if field exists on content privacy field
          if (field && field.length) {
            if (field.length === 1 && (globalCategories.indexOf(field[0]) !== -1 || globalGroups.indexOf(field[0]) !== -1)) {
              continue;
            }
            // add it to the user query
            self.userQuery[userFieldMap[key]] = '$in,' + field.length + ',' + field.join(',');
            cancel = false;
            continue;
          }
        }

        if (cancel) {
          self.userQuery.cancel = true;
        }

      };

      self.initialize = function() {
        var existingCategories = [];
        var existingGroups = [];

        self.queries = [];

        for (var key in privacyMap) {
          if ($scope.content[key] && $scope.content[key].length) {
            $scope.content[key].forEach(function(item) {
              // Do not push global categories to existing
              if (globalCategories.indexOf(item) === -1) {
                existingCategories.push(item);
              }
            });
          }
        }

        if (self.flags.groups && $scope.content.privacy_groups && $scope.content.privacy_groups.length) {
          $scope.content.privacy_groups.forEach(function(group) {
            // Do not push global groups to existing
            if (globalGroups.indexOf(group) === -1) {
              existingGroups.push(group);
            }
          });
        }

        var promises = [];
        var hasCategories = false;
        var hasGroups = false;

        if (existingCategories && existingCategories.length) {
          promises.push(Categories.multipleGet({}, {_ids: existingCategories}).$promise);
          hasCategories = true;
        }

        if (existingGroups && existingGroups.length) {
          promises.push(Groups.find({
            fields: '_id,name',
            _id: '$in,' + existingGroups.length + ',' + existingGroups.join(',')
          }).$promise);
          hasGroups = true;
          self.showGroupDisclaimer = true;
        }

        if (!hasGroups && !hasCategories) {
          return;
        }

        $q.all(promises).then(function(data) {
          var categories = hasCategories ? data[0] : [];
          var groups = hasGroups ? (data[1] || data[0]) : [];
          self.selectedFull = categories.concat(groups);

          // add selections
          categories.forEach(function(item) {
            var type = '';
            typeOptions.forEach(function(opt) {
              if (item[opt]) {
                type = opt;
              }
            });

            if (!type) {
              return;
            }

            legacyName(item);
            item.type = type;
            self.selectedCategoryIds.push(item._id);
            self.queries.push(item);
          });

          groups.forEach(function(item) {
            item.type = 'group';
            item.text = item.name;
            self.selectedGroupIds.push(item._id);
            self.queries.push(item);
          });

          // set queries
          self.setUserQuery();

          if (checkPrivacy()) {
            self.toggle = true;
            return;
          }

          if ($scope.content.private) {
            self.toggle = true;
            return;
          }

        });
      };

      // Initialize
      if ($scope.content) {
        initId = $scope.content._id;
        self.initialize();
      }

      if (!initId) {
        var contentWatch = $scope.$watch('content', function(newVal, oldVal) {
          if (!oldVal && newVal || newVal && oldVal && newVal._id !== oldVal._id) {
            self.initialize();
            contentWatch();
          }
        }, true);
      }

      $scope.$watch('privacy.toggle', function(newVal, oldVal) {
        if (!newVal && oldVal) {
          if ($scope.content.privacy_locations) {
            self.oldLocations = $scope.content.privacy_locations.slice(0);
          }
          if ($scope.content.privacy_departments) {
            self.oldDepartments = $scope.content.privacy_departments.slice(0);
          }
          if ($scope.content.privacy_teams) {
            self.oldTeams = $scope.content.privacy_teams.slice(0);
          }
          if ($scope.content.privacy_org_levels) {
            self.oldOrgLevels = $scope.content.privacy_org_levels.slice(0);
          }
          if ($scope.content.privacy_grades) {
            self.oldGrades = $scope.content.privacy_grades.slice(0);
          }
          if ($scope.content.privacy_groups) {
            self.oldGroups = $scope.content.privacy_groups.slice(0);
          }
          $scope.content.privacy_locations = [];
          $scope.content.privacy_departments = [];
          $scope.content.privacy_teams = [];
          $scope.content.privacy_org_levels = [];
          $scope.content.privacy_grades = [];
          $scope.content.privacy_groups = [];
          $scope.content.private = false;
          self.queries = [];
          if ($scope.onChange) {
            $scope.onChange();
          }
        }
        if (newVal && !oldVal) {
          if (self.oldLocations && self.oldLocations.length || self.oldDepartments && self.oldDepartments.length || self.oldTeams && self.oldTeams.length || self.oldOrgLevels && self.oldOrgLevels.length || self.oldGrades && self.oldGrades.length || self.oldGroups && self.oldGroups.length) {
            $scope.content.privacy_locations = self.oldLocations ? self.oldLocations : [];
            $scope.content.privacy_departments = self.oldDepartments ? self.oldDepartments : [];
            $scope.content.privacy_teams = self.oldTeams ? self.oldTeams : [];
            $scope.content.privacy_org_levels = self.oldOrgLevels ? self.oldOrgLevels : [];
            $scope.content.privacy_grades = self.oldGrades ? self.oldGrades : [];
            $scope.content.privacy_groups = self.oldGroups ? self.oldGroups : [];
            $scope.content.private = false;
            // self.parseOptions();
            if ($scope.onChange) {
              $scope.onChange();
            }
          }
        }
      });
    }],
    controllerAs: 'privacy'
  };
}]);
